var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { AwesomeEvent, ComponentAPI } from '@philips-internal/oswald-ui-core';
import { ClickEventListener, SelectEventListener } from '@philips-internal/oswald-ui-core/lib/component/types/index.js';
import { isValidWidth } from '@philips-internal/oswald-ui-utils';
class CardContainerAPI extends ComponentAPI {
    constructor() {
        super(...arguments);
        this.onClick = new ClickEventListener();
        this.onDoubleClick = new ClickEventListener();
        this.onContextMenuClick = new ClickEventListener();
        this.onSelect = new SelectEventListener();
    }
    /**
     * Returns the data being used to populate the card.
     */
    getData() {
        return this.state.data;
    }
    /**
     * Sets the data that is used to populate the card.
     *
     * @param data - The card updated data.
     */
    setData(data) {
        this.setState({ data });
    }
    /**
     * Returns if the card is disabled.
     */
    isDisabled() {
        return Boolean(this.state.disabled);
    }
    /**
     * Sets if the card should be disabled.
     *
     * @param disabled - If the card should be disabled.
     */
    setDisabled(disabled) {
        this.setState({ disabled });
    }
    /**
     * Returns the card superscription configuration.
     */
    getSuperscription() {
        return this.state.superscription;
    }
    /**
     * Sets the card superscription configuration.
     *
     * @param superscription - The card updated superscription configuration.
     */
    setSuperscription(superscription) {
        this.setState({ superscription });
    }
    /**
     * Returns the card superscription entry.
     */
    getSuperscriptionEntry() {
        return this.state.superscriptionEntry;
    }
    /**
     * Sets the card superscription entry.
     *
     * @param superscriptionEntry - The card updated superscription entry.
     */
    setSuperscriptionEntry(superscriptionEntry) {
        this.setState({ superscriptionEntry });
    }
    /**
     * Returns the card swipe actions.
     */
    getSwipeActions() {
        return this.state.swipeActions;
    }
    /**
     * Sets the card swipe actions.
     *
     * @param swipeActions - The card updated swipe actions.
     */
    setSwipeActions(swipeActions) {
        this.setState({ swipeActions });
    }
    /**
     * Return the card width.
     */
    getWidth() {
        return this.state.width;
    }
    /**
     * Sets the card width.
     *
     * @param width - The card updated width.
     */
    setWidth(width) {
        if (!isValidWidth(width)) {
            throw new Error('[Card Container API]: Invalid width.');
        }
        this.setState({ width });
    }
}
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], CardContainerAPI.prototype, "onClick", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], CardContainerAPI.prototype, "onDoubleClick", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], CardContainerAPI.prototype, "onContextMenuClick", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], CardContainerAPI.prototype, "onSelect", void 0);
export { CardContainerAPI, };
//# sourceMappingURL=card-container-api.js.map